module.exports = __webpack_public_path__ + "static/media/partner_logo.4229ff1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/via/images/partner_logo.svg
// module id = 478
// module chunks = 0